import ErrorBoundary from './components/ErrorBoundary'
import EmojiPickerReact from './EmojiPickerReact'
import { PickerConfig } from './config/config'
import {
  MutableConfigContext,
  useDefineMutableConfig,
} from './config/mutableConfig'

export const EmojiPicker = (props: PickerConfig) => {
  const MutableConfigRef = useDefineMutableConfig({
    onEmojiClick: props.onEmojiClick,
    onReactionClick: props.onReactionClick,
    onSkinToneChange: props.onSkinToneChange,
  })

  return (
    <ErrorBoundary>
      <MutableConfigContext.Provider value={MutableConfigRef}>
        <EmojiPickerReact {...props} />
      </MutableConfigContext.Provider>
    </ErrorBoundary>
  )
}
